<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row>
			<v-col v-for="(report, index) in reports" :key="index" cols="12" md="6" v-if="checkActivePart(report.part)">
				<material-stat-card v-bind="report">
					<template #subtitle>
						<div style="cursor:pointer">
							<router-link :to="report.route">
								{{ report.value }}
							</router-link>
						</div>
					</template>
				</material-stat-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	// Utilities
	export default {
		name: 'ReportView',

		data: () => ({
			reports: [
				// 	{
				// 	actionIcon: 'mdi-calendar',
				// 	actionText: '',
				// 	color: '#FD9A13',
				// 	icon: 'mdi-numeric-1-circle-outline',
				// 	title: '',
				// 	route: '/admin/checkoutThisMonth',
				// 	value: 'لیست اعضایی که در این ماه تسویه شده اند',
				// }, 
				// {
				// 	actionIcon: 'mdi-calendar',
				// 	actionText: '',
				// 	color: '#FD9A13',
				// 	icon: 'mdi-numeric-3-circle-outline',
				// 	title: '',
				// 	route: '/admin/latestMembers',
				// 	value: '20 عضو آخری که به لیست اضافه شده اند',
				// }, {
				// 	actionIcon: 'mdi-calendar',
				// 	actionText: '',
				// 	color: '#FD9A13',
				// 	icon: 'mdi-numeric-4-circle-outline',
				// 	title: '',
				// 	route: '/admin/remainInstallmentCount',
				// 	value: 'باقیمانده تعداد اقساط وام گیرنده ها',
				// },
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-1-circle-outline',
					title: '',
					route: '/admin/report-member-loans',
					value: 'وام های اعضا بر اساس تاریخ',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-2-circle-outline',
					title: '',
					route: '/admin/report-installments-month',
					value: 'گزارش سررسید اقساط بر اساس تاریخ',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-3-circle-outline',
					title: '',
					route: '/admin/report-paid-installments-month',
					value: 'گزارش واریزها بر اساس تاریخ',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-4-circle-outline',
					title: '',
					route: '/admin/checkouted-members',
					value: 'لیست اعضایی که وام تسویه نموده اند',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-5-circle-outline',
					title: '',
					route: '/admin/sponsored-loans',
					value: 'لیست وام های اسپانسری',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-6-circle-outline',
					title: '',
					route: '/admin/contacts',
					value: 'صورت وضیعت طرف حساب ها',
					part: 'contact'
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-7-circle-outline',
					title: '',
					route: '/admin/wallet-transactions/?onlywallet=true',
					value: 'واریز/برداشت های کیف پول',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-8-circle-outline',
					title: '',
					route: '/admin/iran-validity-reports',
					value: 'گزارش اعتبارسنجی های ایران',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-9-circle-outline',
					title: '',
					route: '/admin/organization-duedated-reports',
					value: 'گزارش سررسیدهای سازمانی',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-0-circle-outline',
					title: '',
					route: '/admin/assurances-report',
					value: 'گزارش تضامین',
				},
				{
					actionIcon: 'mdi-calendar',
					actionText: '',
					color: '#FD9A13',
					icon: 'mdi-numeric-0-circle-outline',
					title: '',
					route: '/admin/agentFactors',
					value: 'گزارش صورتحساب های الکترونیکی نمایندگان',
					part: 'agentFactor'
				},

				// {
				// 	actionIcon: 'mdi-calendar',
				// 	actionText: '',
				// 	color: '#FD9A13',
				// 	icon: 'mdi-numeric-9-circle-outline',
				// 	title: '',
				// 	route: '/admin/report-monthly-balance',
				// 	value: 'تراز ماهیانه با لیست اقساط و پس اندازها',
				// }
			],
		}),

		computed: {
		},

		mounted() {
		},
		methods: {
			viewLastMonthInstallments() {

			},
		},
	}
</script>
